<template>
    <div class="user-control ml-3">
        <a-icon
            id="mobile-promos-icon"
            v-tooltip="'Promocje'"
            icon="Promotions"
            class="text-primary user-control__promos"
            @click.native="$router.push({ name: 'promo-list' })"
        />

        <user-diagnostics v-if="!isLotteryUser" />

        <user-news />

        <user-navigation />

        <button
            class="navbar-toggler ml-0"
            data-toggle="collapse"
            data-target="#main-nav"
            aria-controls="main-nav"
            :aria-expanded="isMobileMenuOpen.toString()"
            :aria-label="`${isMobileMenuOpen ? 'Zamknij' : 'Otwórz'} menu nawigacji`"
        >
            <span
                class="navbar-toggler-icon"
                @click="$store.dispatch('toggleMobileMenu')"
            />
        </button>

        <the-btn
            class="btn-sm btn-secondary user-control__help-btn"
            icon="Help"
            text="Pomoc"
            @click="$router.push({ name: 'help' })"
        />
    </div>
</template>

<script>
import UserDiagnostics from '@/components/header/UserDiagnostics'
import UserNews from '@/components/header/UserNews'
import UserNavigation from '@/components/header/UserNavigation'

export default {
    name: 'UserControl',

    components: {
        UserDiagnostics,
        UserNews,
        UserNavigation
    },

    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },

        isMobileMenuOpen() {
            return this.$store.getters.getShowMobileMenu
        }
    }
}
</script>
